var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobileBreadcrumbs",class:{ 'mobileBreadcrumbs--small': _vm.small }},[_c('div',{staticClass:"mobileBreadcrumbs__inner"},[_c(_vm.tag,{tag:"component",staticClass:"mobileBreadcrumbs__link",attrs:{"to":_vm.to,"href":_vm.href},on:{"click":_vm.onClick}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }